var map = {
	"./pr-1.png": "e751",
	"./pr-2.png": "43a9",
	"./pr-3.png": "0e68",
	"./pr-4.png": "a59f",
	"./pr-5.png": "53e3",
	"./pr-6.png": "3251"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8469";